import {
  displayableArtifacts,
  type ArtifactLike,
} from "../../utils/generatedArtifacts"
import "./QuestionArtifacts.style.scss"

type QuestionArtifactsProps = {
  artifacts?: ArtifactLike[] | null
  compact?: boolean
}

const QuestionArtifacts = ({
  artifacts,
  compact = false,
}: QuestionArtifactsProps) => {
  const items = displayableArtifacts(artifacts)
  if (!items.length) return null

  return (
    <div className={`question-artifacts${compact ? " is-compact" : ""}`}>
      {items.map((item) => (
        <figure key={item.id} className="question-artifacts__figure">
          <img src={item.url} alt={item.alt} />
        </figure>
      ))}
    </div>
  )
}

export default QuestionArtifacts
